import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { getValueFromNestedObject } from '../../../../utils/utils/nested-object-extractor.util';
import { EIremboFormlyFormStateKeys } from '../../../models/irembo-formly-formstate-keys.enum';

export enum EImageSourceType {
  FETCHED_DATA = 'FETCHED_DATA',
}

@Component({
  selector: 'irembogov-custom-image',
  templateUrl: './custom-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomImageComponent extends FieldType<FieldTypeConfig> {
  get resolvedImageSrc(): string | null {
    const imageSource: string | undefined = this.field.props['imageSource'];
    const imageSourceType: EImageSourceType | undefined =
      this.field.props['imageSourceType'];

    if (!imageSource || !imageSourceType) return null;

    if (imageSourceType === EImageSourceType.FETCHED_DATA) {
      const fetchedData =
        this.field.options?.formState?.[
          EIremboFormlyFormStateKeys.FETCHED_DATA
        ];
      if (!fetchedData) return null;
      try {
        const value = getValueFromNestedObject(fetchedData, imageSource);
        return typeof value === 'string' ? value : null;
      } catch {
        return null;
      }
    }

    return null;
  }
}
